// Notification API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type NotificationRequests = {
    filterRequestFailedDuringProcessing: RequestConfigFunction<{
        data?: Record<string, any>,
    }>,
    getNotification: RequestConfigFunction<{
        notificationId: number,
    }>,
    updateGeneralData: RequestConfigFunction<{
        notificationId: number,
        data?: Record<string, any>,
    }>,
}

const notificationRequests: NotificationRequests = {
    filterRequestFailedDuringProcessing: ({
        data = {},
    }) => {
        return {
            url: 'notification/filter-request/failed-during-processing',
            method: 'POST',
            data,
        }
    },
    getNotification: ({
        notificationId,
    }) => {
        return {
            url: `notification/${notificationId}`,
            method: 'GET',
        }
    },
    updateGeneralData: ({
        notificationId,
    }) => {
        return {
            url: `notification/${notificationId}/general-data`,
            method: 'PATCH',
        }
    },
}

export default notificationRequests
